import React from 'react';
import { useTheme } from '@cp/ds/src/hooks';
import { mergeSx } from '@cp/ds/src/utils/sx/merge';
import { ClientFavoriteToggleButton } from 'src/features/client/current/favorite';

export const ResumeFavorite: React.FC<React.ComponentProps<typeof ClientFavoriteToggleButton>> = ({ itemSx, ...props }) => {
  const theme = useTheme();

  return (
    <ClientFavoriteToggleButton
      {...props}
      size="small"
      square
      sx={mergeSx(
        {
          backgroundColor: theme.palette.white,
          borderColor: theme.palette['gray middle'],
          zIndex: 99,
          position: 'absolute',
          top: 16,
          right: 16,
        },
        itemSx,
      )}
      variant="secondary"
    />
  );
};
